<template>
  <div class="container">
    <div v-for="(item, index) in settingList">
      <SettingItem :item="item"/>
    </div>
  </div>
</template>

<script>

import TitleBarStore from '@/components/widgets/TitleBarStore'
import SettingItem from '@/components/widgets/SettingItem'
import app from '@/AppData'
import Constants from '@/components/setting/Constants'
import jsbridge from '@/jsbridge'
import lubanapi from '@/lubanapi'

export default {
  name: 'VipProloguePage',

  components: {
    SettingItem
  },

  data () {
    let that = this

    return {

      settingList: [
        // {
        //   divider: true,
        //   bgColor: '#FAFAFA',
        //   height: 0.8,
        // },
        {
          isTitleItem: true,
          title: '定制助理',
        },
        {
          icon: '@/../static/sound_icon.png',
          title: '助理声音',
          desc: '多种音色可选',
          content: Constants.getVoiceRoleName(!app.isVip() ? 0 : app.getData().userSetting.voiceRole),
          go: true,
          onClick: function () {
            console.log(this.title)
            that.$router.push({
              path: '/ai_sound_page'
            })

            lubanapi.reportseer('AICall_Member_Customization_Page_Select_Character_Click', app.isVip() ? '1' : '0')
          }
        },
        {
          divider: true,
          bgColor: '#FAFAFA',
          height: 0.1
        },
        {
          icon: '@/../static/prologue_icon.png',
          title: '自定义接听开场白',
          desc: '助理开场白类型选择',
          content: Constants.getPrologueName(),
          go: true,
          onClick: function () {
            console.log(this.title)
            that.$router.push({
              path: '/vip_prologue_page'
            })
            lubanapi.reportseer('AICall_Member_Customization_Page_Opening_Click', app.isVip() ? '1' : '0')
          }
        },
        {
          divider: true,
          bgColor: '#FAFAFA',
          height: 0.1
        },
        {
          icon: '@/../static/refuse_icon.png',
          title: '谢绝骚扰来电设置',
          desc: '助理直接谢绝来电并挂断',
          go: true,
          onClick: function () {
            console.log(this.title)
            that.$router.push({
              path: '/vip_refuse_page'
            })
            lubanapi.reportseer('AICall_Member_Customization_Page_Decline_Scene_Click', app.isVip() ? '1' : '0')
          }
        },
        {
          isTitleItem: true,
          title: '专属接听设置',
        },
        {
          icon: '@/../static/sms_notify_icon.png',
          title: '来电短信通知',
          desc: '来电后通过短信即时通知你',
          isSwitch: true,
          switch: !app.isVip() ? false : app.getData().userSetting.sendMsgNotify,
          switchTouch: app.isVip(),
          onClick: function () {
            lubanapi.reportseer('AICall_Member_Customization_Page_SMS_Notice_Click', app.isVip() ? '1' : '0')
            console.log(this.title)
            if (!app.isVip()) {
              // 非会员，弹窗
              jsbridge.showVipGuideDialog(that)
              return
            }
            let sendMsgNotify = app.getData().userSetting.sendMsgNotify
            app.getData().userSetting.sendMsgNotify = !sendMsgNotify
            app.reportProfile().then(value => {
              console.log('sendMsgNotify, reportProfile success')
            }, reason => {
              console.log('sendMsgNotify, reportProfile fail, reason:' + JSON.stringify(reason))
            })
          }
        }
      ]
    }
  },
  mounted () {
    TitleBarStore.store.showvipicon()
    if (app.isVip()) {
      lubanapi.reportseer('AICall_Member_Customization_Page_Shown', '1')
    } else {
      lubanapi.reportseer('AICall_Member_Customization_Page_Shown', '0')
    }
  }
}

</script>

<style scoped>


.container {
  width: 100%;
  height: 100%;
  background-color: #FAFAFA;
}

</style>



// WEBPACK FOOTER //
// src/components/setting/VipSettingPage.vue